<template>
  <div v-if="disponibiliteAvailability">
    <b-modal v-model="isModalRecharge"
              has-modal-card class="modal">
      <div class="card modal-card-panier modal-card-border">
        <div class="card-content">
          <section class="has-text-centered">
            <b-icon
              icon="alert"
              size="is-large"
              type="is-warning"
              custom-class="font-size-54">
            </b-icon>
            <p class="subtitle is-5 has-text-centered my-20">Oupss...</p>
            <p class="has-text-default">Aucune face ne correspond à votre recherche.</p>
          </section>
          <br>
          <footer>
            <div class="has-text-centered">
              <button class="button is-info button-modal has-text-centered"
                      @click="recharge">
                Recharger
              </button>
            </div>
          </footer>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');

export default {
  name: 'recharge-faces-lc',
  props: {
    listeFaces: {
      type: Array,
    },
  },
  data() {
    return {
      valueProposableLcChange: false,
    };
  },
  watch: {
    proposableLc() {
      this.valueProposableLcChange = true;
    },
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      disponibiliteAvailability: 'disponibiliteAvailability',
      tabFiltreDispo: 'tabFiltreDispo',
      address: 'address',
      rayon: 'rayon',
      filtresDynamiques: 'filtresDynamiques',
      proposableLc: 'proposableLc',
    }),
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    isModalRecharge() {
      return (this.tabFiltreDispo.flat().length > 0 || this.valueProposableLcChange)
        && this.listeFaces.length === 0;
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setAddFilterProperty: types.ADD_FILTER_PROPERTY,
      removeFilter: types.REMOVE_FILTER,
      setProposableLc: types.SET_PROPOSABLE_LC,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionFiltres: 'gestionFiltres',
      actionsGestionPanneauxLC: 'gestionPanneauxLC',
    }),
    recharge() {
      this.removeFilter();
      this.setProposableLc('1');
      this.actionsGestionFiltres();
      this.$emit('recharge');
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recharge.vue